<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconSort',
  svgType: 'color',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-sort', 'type-color'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg fill="none" viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path fill="none" d="M0 0h24v24H0z"/><path fill="currentColor" fill-opacity=".8" fill-rule="evenodd" d="m12.38 4.96 3.93 4.71c.27.33.04.83-.38.83H8.06c-.42 0-.65-.5-.38-.83l3.93-4.71c.2-.24.57-.24.77 0" class="sort_svg__up-arrow"/><path fill="currentColor" fill-opacity=".8" fill-rule="evenodd" d="m12.38 19.03 3.93-4.71a.5.5 0 0 0-.38-.82H8.06a.5.5 0 0 0-.38.82l3.93 4.71c.2.24.57.24.77 0" class="sort_svg__down-arrow"/>
    </template>
  </svg>
</template>